"use client";

import React, { useEffect, useState } from "react";
import { MapPin, Clock, Building2, ArrowRight } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: "hq",
  city: "Oslo",
  country: "Norge",
  address: "Aker Brygge 1, 0123 Oslo",
  top: "38%",
  left: "22%",
  timezone: "Europe/Oslo",
  isHQ: true
}, {
  id: "eu",
  city: "Bergen",
  country: "Norge",
  address: "Bryggen 5, 5003 Bergen",
  top: "28%",
  left: "48%",
  timezone: "Europe/Oslo",
  isHQ: false
}, {
  id: "asia",
  city: "Trondheim",
  country: "Norge",
  address: "Munkegata 1, 7013 Trondheim",
  top: "35%",
  left: "82%",
  timezone: "Europe/Oslo",
  isHQ: false
}, {
  id: "oceania",
  city: "Stavanger",
  country: "Norge",
  address: "Øvre Holmegate, 4006 Stavanger",
  top: "75%",
  left: "88%",
  timezone: "Europe/Oslo",
  isHQ: false
}];
export default function OurGlobalKitchen() {
  const [mounted, setMounted] = useState(false);
  const [currentTime, setCurrentTime] = useState<Date>(new Date());
  useEffect(() => {
    setMounted(true);
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);
  const getLocalTime = (timeZone: string) => {
    if (!mounted) return "--:--";
    try {
      return new Intl.DateTimeFormat("en-GB", {
        timeStyle: "short",
        timeZone
      }).format(currentTime);
    } catch (e) {
      return "--:--";
    }
  };
  return;
}